/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Child_Teen_BadgeInputs */

const fr_guardian_child_teen_badge = /** @type {(inputs: Guardian_Child_Teen_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ado`)
};

/**

* @param {Guardian_Child_Teen_BadgeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_child_teen_badge = /** @type {((inputs?: Guardian_Child_Teen_BadgeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Child_Teen_BadgeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_child_teen_badge(inputs)
});